"use client"
import { BlockRenderer, Container, CustomBreadcrumbs, TopBanner } from "ui"
import { findProperty, getBreadCrumbs } from "utils"
import FinancialReportsTab from "../Financial-reports/FinancialReportsTab"

type Props = {
  data: any
  locale: string
}

function InvestorPresentation({ data, locale }: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const components = {
    topBanner: TopBanner,
    financialReportsMain: FinancialReportsTab,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  const hasBanner = blocks?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )
  return (
    <>
      <Container>
        <CustomBreadcrumbs current={selfObject} parents={parents} />
      </Container>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner,
          }
        } else if (block.blockType === "financialReportsMain") {
          additionalProps = {
            eventName: "מצגות למשקיעים",
          }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            props={additionalProps}
          />
        )
      })}
    </>
  )
}

export default InvestorPresentation
